<template>
  <v-dialog
    v-model="showSelectCoverImageDialog"
    @keydown.esc="!isBusy ? (showSelectCoverImageDialog = false) : null"
    max-width="960"
    :persistent="isBusy"
  >
    <v-card>
      <v-card-title> <slot name="header"></slot> </v-card-title>
      <v-card-text>
        <v-radio-group
          v-model="currentCoverType"
          :class="['d-block', $style.radioContainer]"
        >
          <v-layout
            :row="!$vuetify.breakpoint.xs"
            :column="$vuetify.breakpoint.xs"
            justify-center
          >
            <v-flex
              :class="[
                $style.radioContainer__container,
                $vuetify.breakpoint.xs
                  ? $style.radioContainer__container__xs
                  : null
              ]"
            >
              <div
                :class="[
                  $style.radioContainer__borderBox,
                  $style.radioContainer__radioContainer,
                  $vuetify.breakpoint.xs
                    ? $style.radioContainer__radioContainer__xs
                    : null
                ]"
                @click="onclickSimpleCoverArea"
              >
                <div
                  :class="[
                    $style.radioContainer__radio,
                    $vuetify.breakpoint.xs
                      ? $style.radioContainer__radio__xs
                      : null
                  ]"
                >
                  <v-radio value="simple"></v-radio>
                </div>

                <v-responsive
                  :class="[
                    'ma-auto',
                    $style.imageWrapper,
                    $style.radioContainer__coverImageBorder
                  ]"
                  max-width="100%"
                  :aspect-ratio="1 / Math.sqrt(2)"
                  :width="coverImageSize"
                >
                  <v-img
                    width="100%"
                    height="100%"
                    :src="
                      isFrontCover
                        ? frontCoverDefaultImage
                        : backCoverDefaultImage
                    "
                  ></v-img>
                </v-responsive>

                <div class="ma-1">{{ lang.default_cover_name }}</div>
              </div>
            </v-flex>
            <v-flex
              :class="[
                $style.radioContainer__container,
                $vuetify.breakpoint.xs
                  ? $style.radioContainer__container__xs
                  : null
              ]"
            >
              <div
                :class="[
                  $style.radioContainer__borderBox,
                  $style.radioContainer__radioContainer,
                  $vuetify.breakpoint.xs
                    ? $style.radioContainer__radioContainer__xs
                    : null
                ]"
                @click="onClickCoverInputArea"
              >
                <div
                  :class="[
                    $style.radioContainer__radio,
                    $vuetify.breakpoint.xs
                      ? $style.radioContainer__radio__xs
                      : null
                  ]"
                >
                  <v-radio value="user_upload"></v-radio>
                </div>

                <v-responsive
                  :class="[
                    'ma-auto',
                    $style.imageWrapper,
                    $style.radioContainer__coverImageBorder
                  ]"
                  max-width="100%"
                  :aspect-ratio="1 / Math.sqrt(2)"
                  :width="coverImageSize"
                >
                  <v-img
                    v-if="coverImageDataUrl || userCoverImageUrl"
                    width="100%"
                    height="100%"
                    :src="coverImageDataUrl || userCoverImageUrl"
                  ></v-img>
                  <div
                    v-else
                    :class="[
                      'grey--text text--darken-1 px-2',
                      $style.radioContainer__nothingFileText
                    ]"
                  >
                    {{ lang.cover_edit_dialog_nothing_file }}
                  </div>
                </v-responsive>

                <v-btn
                  color="primary"
                  :class="$style.btnTextStyle"
                  :disabled="currentCoverType !== 'user_upload'"
                >
                  {{ lang.cover_edit_dialog_select_file }}
                </v-btn>

                <input
                  type="file"
                  style="display: none"
                  ref="coverImageFileInput"
                  accept="image/png,image/jpeg, image/jpg"
                  @change="onChangeCoverImageFileInput"
                />
                <v-alert
                  v-for="(message, index) in postCoverErrorMessages"
                  :key="index"
                  :value="true"
                  type="error"
                >
                  {{ message }}
                </v-alert>
              </div>
            </v-flex>
          </v-layout>
        </v-radio-group>

        <v-layout justify-end>
          <v-btn
            :class="$style.btnTextStyle"
            color="primary"
            @click="onClickCoverTypeSaveButton"
            :disabled="
              currentCoverType === 'user_upload' &&
                !this.userCoverImageUrl &&
                !this.coverImageFile
            "
          >
            {{ lang.cover_edit_dialog_apply }}
          </v-btn>

          <slot name="closeButton"></slot>
          <v-btn
            :class="$style.btnTextStyle"
            color="default"
            @click="showSelectCoverImageDialog = false"
            :disabled="isBusy"
          >
            {{ lang.cover_edit_dialog_cancel }}
          </v-btn>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
const MAX_IMAGE_FILE_SIZE_HUMAN = 32;
const MAX_IMAGE_FILE_SIZE = 1024 * 1024 * MAX_IMAGE_FILE_SIZE_HUMAN;

import CoverDefault from "./assets/default_cover_simple.png";
import ua from "../../../lib/useragent.js";
import {
  dataUrlToBlob,
  loadImageWithOrientationCorrection
} from "../../../lib/image";

export default {
  name: "vc-share-comic-cover-select-dialog",
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    coverType: {
      type: String,
      default: "simple"
    },
    isFrontCover: {
      type: Boolean,
      default: false
    },
    userCoverImageUrl: {
      type: String,
      default: ""
    },
    updateCoverType: {
      type: Function,
      default: () => {}
    },
    postCoverImage: {
      type: Function,
      default: () => {}
    },
    isBusy: {
      type: Boolean,
      default: false
    },
    lang: {
      type: Object,
      default: () => ({})
    },
    isFirefox: {
      type: Boolean,
      default: false
    },
    isAndroidOs: {
      type: Boolean,
      default: false
    },
    isIce: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      currentCoverType: "",
      previousCoverType: "",
      frontCoverDefaultImage: CoverDefault,
      backCoverDefaultImage: CoverDefault,
      coverImageFile: null,
      coverImageFileName: "",
      coverImageDataUrl: null,
      postCoverErrorMessages: [],
      showSelectCoverImageDialog: this.showDialog
    };
  },
  methods: {
    onCloseFileSelector() {
      setTimeout(() => {
        const notExistCoverImage =
          !this.coverImageDataUrl && !this.userCoverImageUrl;
        const fileLength = this.$refs.coverImageFileInput.value.length;
        let isEmptyInputFile = fileLength === 0;
        // FirefoxとICEはファイル選択時の挙動が異なるため別処理
        if (this.isFirefox || this.isIce) {
          isEmptyInputFile = true;
        }

        // 表紙ファイル未選択、かつ、アップロード済み表紙画像がない場合、規定シンプルに変更
        if (notExistCoverImage && isEmptyInputFile) {
          this.currentCoverType = "simple";
          this.previousCoverType = "simple";
        }
        this.changeFileSelectorCloseListener(false);
      }, 200);
    },
    onClickCoverInputArea() {
      const existCoverImage = this.coverImageDataUrl || this.userCoverImageUrl;

      if (this.previousCoverType === "user_upload" || !existCoverImage) {
        this.$refs.coverImageFileInput.click();
        if (!this.isAndroidOs) {
          this.changeFileSelectorCloseListener(true);
        }
      }

      // AndroidOS以外の場合、もしくは表紙画像選択済みの場合、クリック時に表紙選択状態を切り替える
      if (!this.isAndroidOs || existCoverImage) {
        this.currentCoverType = "user_upload";
      }
      this.previousCoverType = "user_upload";
    },
    onclickSimpleCoverArea() {
      this.currentCoverType = "simple";
      this.previousCoverType = "simple";
    },
    changeFileSelectorCloseListener(isAdded) {
      // ファイル選択ダイアログのキャンセル押下を検知
      // 一部ブラウザではonfocusイベントを取得できないため、mouseイベントで判定
      const canDetectMouseEvent = this.isFirefox || this.isIce;
      let eventName = "onfocus";
      if (canDetectMouseEvent) {
        eventName = "onmousemove";
      }

      if (isAdded) {
        document.body[eventName] = this.onCloseFileSelector;
      } else {
        document.body[eventName] = null;
      }
    },
    onChangeCoverImageFileInput(e) {
      const files = e.target.files;
      this.postCoverErrorMessages = [];

      if (files[0] == undefined) {
        return;
      }

      const file = files[0];

      if (file.type !== "image/jpeg" && file.type !== "image/png") {
        const message = this.lang.cover_edit_error_file_type.replace(
          ":filename",
          file.name
        );
        this.postCoverErrorMessages.push(message);
        return;
      }

      if (file.size > MAX_IMAGE_FILE_SIZE) {
        const message = this.lang.cover_edit_error_image_size
          .replace(":filename", file.name)
          .replace(":max_size", MAX_IMAGE_FILE_SIZE_HUMAN);
        this.postCoverErrorMessages.push(message);
        return;
      }

      this.coverImageFileName = file.name;

      if (ua.getBrowser().name === "IE") {
        // IEではOrientationの補正が期待動作しないため、補正しない画像をそのまま使用する
        const fr = new FileReader();
        fr.readAsDataURL(file);
        fr.onload = () => {
          this.coverImageFile = file;
          this.coverImageDataUrl = fr.result;
        };
      } else if (this.isAndroidOs) {
        // AndroidOSの場合、画像アップロード時に表紙選択状態を切り替える
        if (this.currentCoverType === "simple") {
          this.currentCoverType = "user_upload";
        }

        loadImageWithOrientationCorrection(file)
          .then(canvas => {
            this.coverImageFile = dataUrlToBlob(canvas.toDataURL());
            this.coverImageDataUrl = canvas.toDataURL();
          })
          .then(() => {
            const notExistCoverImage =
              !this.coverImageDataUrl && !this.userCoverImageUrl;
            if (notExistCoverImage) {
              this.currentCoverType = "simple";
            }
          });
      } else {
        loadImageWithOrientationCorrection(file).then(canvas => {
          this.coverImageFile = dataUrlToBlob(canvas.toDataURL());
          this.coverImageDataUrl = canvas.toDataURL();
        });
      }
    },
    async onClickCoverTypeSaveButton() {
      switch (this.currentCoverType) {
        case "simple":
          this.updateCoverType(this.currentCoverType);
          this.showSelectCoverImageDialog = false;
          break;

        case "user_upload":
          if (!this.userCoverImageUrl && !this.coverImageFile) {
            this.postCoverErrorMessages = [];
            this.postCoverErrorMessages.push(
              this.lang.cover_edit_error_require_file
            );
            break;
          }

          if (this.coverImageDataUrl) {
            this.updateCoverType(this.currentCoverType);
            const image = new Image();
            image.src = this.coverImageDataUrl;
            image.onload = async () => {
              await this.postCoverImage({
                file: this.coverImageFile,
                name: this.coverImageFileName,
                width: image.naturalWidth,
                height: image.naturalHeight
              });
              this.showSelectCoverImageDialog = false;
            };
            break;
          }

          if (this.userCoverImageUrl) {
            this.updateCoverType(this.currentCoverType);
            this.showSelectCoverImageDialog = false;
            break;
          }

          break;
      }
    },
    initialData() {
      this.currentCoverType = this.coverType;
      this.coverImageFile = null;
      this.coverImageDataUrl = null;
      this.postCoverErrorMessages = [];
    },
    emitEventUpdateShowCoverDialog(value) {
      this.$emit("updateShowCoverDialog", {
        isFront: this.isFrontCover,
        showDialog: value
      });
    }
  },
  computed: {
    coverImageSize: function() {
      switch (this.$vuetify.breakpoint.name) {
        case "sm":
        case "xs":
          return "200px";
        default:
          return "300px";
      }
    }
  },
  watch: {
    showDialog() {
      this.showSelectCoverImageDialog = this.showDialog;

      if (this.showDialog) {
        this.initialData();
      }
    },
    showSelectCoverImageDialog() {
      if (!this.showSelectCoverImageDialog) {
        this.emitEventUpdateShowCoverDialog(this.showSelectCoverImageDialog);
      }
    }
  }
};
</script>

<style module lang="scss">
.btnTextStyle {
  text-transform: none !important;
}

.radioContainer {
  width: 100%;

  &__container {
    flex-basis: 50% !important;
    padding: 0 8px;

    &__xs {
      flex-basis: auto !important;
      padding: 8px 0;
    }
  }

  &__borderBox {
    border: solid;
    border-color: gray;
    border-radius: 10px;
    padding: 24px;
    text-align: center;
    cursor: pointer;
  }

  &__radioContainer {
    position: relative;
    margin-top: 40px;
    height: calc(100% - 40px);

    &__xs {
      margin-top: 0;
      margin-left: 40px;
      height: 100%;
    }
  }

  &__radio {
    position: absolute;
    left: 50%;
    top: -40px;
    transform: translateX(-50%);

    &__xs {
      left: -40px;
      top: 50%;
      transform: translateY(-50%);
    }

    * {
      margin-right: 0 !important;
    }
  }

  &__coverImageBorder {
    border: 1px solid gray;
  }

  &__nothingFileText {
    position: absolute;
    width: 100%;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
  }
}
</style>
